import React from 'react';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import gaParams from '../../../../utilities/analytics/constants';
import BankPackage from './BankPackage';
import PackageHeading from './PackageHeading';
import LastUses from './LastUses';

const BankPackages = ({bankPackages = null, isCurrentCycle = false, cycleStart = ''}) => {
  let returned = '';
  let allPackages = '';

  if (bankPackages != null) {
    const packageSearch = isCurrentCycle ? bankPackages.packages : bankPackages.packages.filter((p) => p.packageStatus != 'Future');
    allPackages = packageSearch.map((p) => {
      return <BankPackage cycleStart={cycleStart} isCurrentCycle={isCurrentCycle} thisPackage={p} key={bankPackages.packages.indexOf(p)} />;
    });
    const tooltipText = `
        <b>
          השימושים שביצעתם
          <br />
          במסגרת החבילות שרכשתם
        </b>
        <br />
        כאן מוצגים השימושים במסגרת חבילות חו"ל הכוללים כמות קבועה מראש של גלישה או שיחות או הודעות (או שילוב ביניהם).
        <br />
        <b>במידה ומוצגים שימושי "שיחות" או "הודעות":</b>
        <br />
        השימושים המוצגים תחת "שיחות" כוללים את דקות השיחה הכלולות בחבילה בלבד.
        <br />
        השימושים המוצגים תחת "הודעות" כוללים את ההודעות הכלולות בחבילה בלבד.
      `;
    const lastUseRender = isCurrentCycle ? (
      <div class='PackageBody' style={{borderTop: '0'}}>
        <LastUses
          cycleStart={cycleStart}
          lastUsesArr={bankPackages?.lastUses}
          onclick={() => {
            gaEvent(
              gaParams.ABROAD_DATAUSAGES_LASTUSESCLICK.category,
              gaParams.ABROAD_DATAUSAGES_LASTUSESCLICK.eventType,
              'שימושים במסגרת חבילות'
            );
          }}
        />
      </div>
    ) : null;
    returned = (
      <div className='Package BankPackage'>
        <PackageHeading
          text='שימושים במסגרת חבילות'
          tooltipId={isCurrentCycle ? 'bankPackagesHeading_currentCycle' : 'bankPackagesHeading_previousCycle'}
          onclick={() => {
            gaEvent(
              gaParams.ABROAD_DATAUSAGES_TOOLTIPCLICK.category,
              gaParams.ABROAD_DATAUSAGES_TOOLTIPCLICK.eventType,
              'שימושים במסגרת חבילות'
            );
          }}
          tooltipText={tooltipText}
        />
        {allPackages}
        {lastUseRender}
      </div>
    );
  }
  return returned;
};

export default BankPackages;
